import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// Helpers
import {
    checkBrowserSupport,
    BrowserNotSupported,
    lazyWithRetry as lazy,
    SlimLayout,
} from '@cc/common';
import { NavigationInitializer, AppInsightsNavigationTracker, Routes, Route, TitledRoute } from '@cc/common/routing';
import { appInsightsHistory } from './appInsightsHistory';

// Pages
const ChangePassword = lazy(() => import('pages/ChangePassword'));
const Error = lazy(() => import('pages/Error'));
const ForgotPassword = lazy(() => import('pages/ForgotPassword'));
const Login = lazy(() => import('pages/Login'));
const Logout = lazy(() => import('pages/Logout'));
const TwoFactor = lazy(() => import('pages/TwoFactor'));
const TwoFactorValidate = lazy(() => import('pages/TwoFactorValidate'));
const UserEnrollment = lazy(() => import('pages/UserEnrollment'));
const TermsOfUsePage = lazy(() => import('pages/siteDocuments/TermsOfUsePage'));
const PrivacyPolicyPage = lazy(() => import('pages/siteDocuments/PrivacyPolicyPage'));
const ReleaseNotePage = lazy(() => import('pages/siteDocuments/ReleaseNotePage'));

import LoginLayout from 'layouts/LoginLayout';
import PlainLayout from 'layouts/PlainLayout';

import { TokenWatcher } from 'components/TokenWatcher';

// Vite's BASE_URL always has a trailing slash; strip it for the router basename.
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '');

function AppRouter() {
    const isBrowserSupported = checkBrowserSupport();
    return (
        <React.Fragment>
            <BrowserRouter basename={basename} future={{ v7_startTransition: true }}>
                <NavigationInitializer />
                <AppInsightsNavigationTracker history={appInsightsHistory} />
                <TokenWatcher />
                {!isBrowserSupported ? (
                    <LoginLayout>
                        <BrowserNotSupported />
                    </LoginLayout>
                ) : (
                    <Routes>
                        <Route path="/error" element={<TitledRoute title="Error"><Error /></TitledRoute>} />
                        <Route path="/logout" element={<TitledRoute title="Logout"><LoginLayout><Logout /></LoginLayout></TitledRoute>} />
                        <Route path="/forgot-password" element={<TitledRoute title="Forgot Password"><LoginLayout><ForgotPassword /></LoginLayout></TitledRoute>} />
                        <Route path="/change-password" element={<TitledRoute title="Change Password"><LoginLayout><ChangePassword /></LoginLayout></TitledRoute>} />
                        <Route path="/two-factor" element={<TitledRoute title="Two Factor"><LoginLayout><TwoFactor /></LoginLayout></TitledRoute>} />
                        <Route path="/two-factor-validate" element={<TitledRoute title="Two Factor"><LoginLayout><TwoFactorValidate /></LoginLayout></TitledRoute>} />
                        <Route path="/user-enrollment" element={<TitledRoute title="Enrollment"><PlainLayout><UserEnrollment /></PlainLayout></TitledRoute>} />
                        <Route path="/PrivacyPolicy/:siteDocumentId?" element={<TitledRoute title="Privacy Policy"><SlimLayout className="h-full"><PrivacyPolicyPage /></SlimLayout></TitledRoute>} />
                        <Route path="/TermsOfUse/:siteDocumentId?" element={<TitledRoute title="Terms Of Use"><SlimLayout className="h-full"><TermsOfUsePage /></SlimLayout></TitledRoute>} />
                        <Route path="/ReleaseNote/:siteDocumentId?" element={<TitledRoute title="Release Note"><SlimLayout className="h-full"><ReleaseNotePage /></SlimLayout></TitledRoute>} />
                        <Route path="/*" element={<TitledRoute title="Login"><LoginLayout><Login /></LoginLayout></TitledRoute>} />
                    </Routes>
                )}
            </BrowserRouter>
        </React.Fragment>
    );
}
export default AppRouter;
